class TabFeatures extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
        this.items = this.querySelectorAll('.tab-feat__item')
        
        this.container = this.querySelector('.tab-feat__container')
        this.rightTitle = this.querySelector('.tab-feat__right-title')
        this.rightDescription = this.querySelector('.tab-feat__right-description')

        this.items.forEach(item => {
            item.addEventListener('click', (e) => {
                this.items.forEach(item2 => item2.classList.remove('tab-feat__item--active'))
                item.classList.add('tab-feat__item--active')
                const title = item.querySelector('h5')
                const description = item.querySelector('.tab-feat__item-description')

                this.rightTitle.innerText = title.innerText;
                this.rightDescription.innerText = description.innerText;

            })
        })
    }
  
    disconnectedCallback() {}
  }
  
  customElements.define("tab-features", TabFeatures);
  